import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const TableWrapper = styled.div`
  ${({ theme }) => `
    padding: ${theme.space.mobile.base};
    padding-bottom: ${theme.space.desktop.large};
    margin-bottom: ${theme.space.mobile.base};
    background: ${theme.color.white};
    color: ${theme.color.grey};
  `}

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.base};
    padding-bottom: ${theme.space.desktop.large};
  `}
`

export const SearchWrapper = styled.div`
  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.base};
  `}
`

export const TableInfoWrapper = styled.div`
  text-align: right;

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.sm`
    margin-top: ${theme.space.desktop.base};
  `}
`
